export const WEEK_START_SUNDAY = 0;
export const WEEK_START_MONDAY = 1;

export type WeekStart = typeof WEEK_START_SUNDAY | typeof WEEK_START_MONDAY;
